<template>
  <div class="attrs">
    <div class="video" v-if="imageList && imageList.length > 0">
      <div class="name">图片</div>
      <div class="video-container">
        <div @click="previewImg(imageList, index)" class="video-item" v-for="(item, index) in imageList" :key="index">
          <img :src="$isCdn(item.eventAttrSmallImgUrl)" alt />
        </div>
      </div>
    </div>
    <div class="video" v-if="homeWorkList && homeWorkList.length > 0">
      <div class="name">作业</div>
      <div class="video-container">
        <div
          @click="previewHomeWorkImg(homeWorkList, index)"
          class="video-item"
          v-for="(item, index) in homeWorkList"
          :key="index"
        >
          <img :src="$isCdn(item.homeworkUrl)" alt />
        </div>
      </div>
    </div>
    <!-- 附件 -->
    <div class="video" v-if="attrList && attrList.length > 0">
      <div class="name">附件</div>
      <div class="video-container">
        <div class="attr-item" v-for="(item, index) in attrList" :key="index">
          <div class="attr-cover">
            <!-- <img src="@/assets/image/home/ppt.png" alt /> -->
            <img :src="fileType(item.eventAttrName)" alt />
          </div>
          <div class="attr-title van-multi-ellipsis--l2">{{ item.eventAttrName }}</div>
        </div>
      </div>
    </div>
    <div v-if="attrList && homeWorkList && imageList">
      <div v-if="attrList.length === 0 && homeWorkList.length === 0 && imageList.length === 0" class="no-data">
        <img src="@/assets/image/no_data.svg" alt="" />
        <div class="value">暂无附件</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    videoList() {
      return this.activeInfo && this.activeInfo.videoList
    },
    imageList() {
      return this.activeInfo && this.activeInfo.imageList
    },
    homeWorkList() {
      if (this.activeInfo && this.activeInfo.eventAptRecord && this.activeInfo.eventAptRecord.homeworkList) {
        return this.activeInfo.eventAptRecord.homeworkList
      }
      return []
    },
    attrList() {
      return this.activeInfo && this.activeInfo.attrList
    },
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    fileType(name) {
      const typeArr = name.split('.')
      const type = typeArr[typeArr.length - 1]
      if (type === 'mp4') {
        return require('@/assets/image/home/content_icon_mp42x.png')
      } else if ((type === 'png') | (type === 'jpg') | (type === 'jpeg') | (type === 'gif')) {
        return require('@/assets/image/home/img.png')
      } else {
        return require('@/assets/image/home/xls.png')
      }
    },
    previewImg(obj, index) {
      const images = obj.map(item => this.$isCdn(item.eventAttrPath))
      this.$ImagePreview({
        images,
        startPosition: index
      })
    },
    previewHomeWorkImg(obj, index) {
      const images = obj.map(item => this.$isCdn(item.homeworkUrl))
      this.$ImagePreview({
        images,
        startPosition: index
      })
    }
  }
}
</script>

<style scoped lang="scss">
.attrs {
  padding: 16px;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.video {
  margin-bottom: 10px;
  div.name {
    margin-bottom: 10px;
    font-weight: 600;
  }
}
.video-container {
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.video-item {
  display: inline-block;
  margin-right: 10px;
  // word-wrap: none;
  .img-container {
    padding: 2px 2px 0 2px;
    border: 1px solid transparent;
    border-radius: 4px;
    &.active {
      border-color: #4465f3;
    }
  }
  .title {
    font-size: 14px;
    color: #909399;
    max-width: 130px;
  }
  img {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    object-fit: cover;
  }
}

/* 附件 */
.attr-item {
  margin-right: 10px;
  width: 190px;
  height: 60px;
  background: #f4f6f9;
  border-radius: 8px;
  padding: 10px;
  display: inline-block;
  vertical-align: middle;
  .attr-cover {
    vertical-align: middle;
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .attr-title {
    vertical-align: middle;
    display: inline-block;
    height: 40px;
    width: 120px;
    line-height: 1.5;
    color: #606266;
    font-size: 14px;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
  }
}

.no-data {
  text-align: center;
  img {
    margin-top: 40px;
    width: 80px;
  }
  .value {
    color: #c0c4cc;
  }
}
</style>
